function findViewByIdOrName(companyViews: UserView[], view: UserView): UserView | undefined {
  return companyViews.find(v => v.id === view.id) || companyViews.find(v => v.name === view.name);
}

export default findViewByIdOrName;
